<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
                <el-tab-pane label="单问题列表" v-permission="'operating.house-topic.house-topic-model-ask.list'">
                    <singleQuesList></singleQuesList>
                </el-tab-pane>
                <el-tab-pane label="多问题列表" v-permission="'operating.house-topic.house-topic-model-ask.list'">
                    <manyQuesList></manyQuesList>
                </el-tab-pane>
        </el-tabs>
    </div>
</template>
<!-- <style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style> -->
<script>
    const singleQuesList = ()=>import('./singleQuesList/list.vue');
    const manyQuesList = ()=>import('./manyQuesList/list.vue');
    export default {
        data () {
            return {
               
            }
        },
        components:{
            singleQuesList,
            manyQuesList
        },
        mounted () {

        },
        methods: {
        }
    }
</script>

<style scoped>
</style>



















